import React, { useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useField } from "react-final-form";
import { SelectOption } from "../../../../common/components/input/Select";

type CategoryAutocompleteProps = {
  categories: SelectOption[];
  value?: string;
};
export const CategoryAutocomplete: React.FC<CategoryAutocompleteProps> = ({
  categories,
  value,
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const { input } = useField("category", { initialValue: value });

  const label = useMemo(
    () => (isFocused || input.value ? "Choose a category or create your own" : "Category"),
    [isFocused, input.value],
  );

  return (
    <Autocomplete
      id="category-autocomplete"
      className="w-300"
      options={Array.from(new Set([...categories])).sort()}
      value={input.value}
      onInputChange={(_event, value) => input.onChange(value)}
      freeSolo
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            id="category"
            fullWidth={true}
            variant="outlined"
            placeholder={"Category"}
            label={label}
            InputProps={{ ...params.InputProps, type: "text" }}
            InputLabelProps={{ required: false }}
            required
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
          />
        );
      }}
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
    />
  );
};
